var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelDisplayAd14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.502 2.5c.551 0 .998.446.998.998v7.004c0 .551-.446.998-.998.998H9.33L8.282 8.907l.897-.038c.515-.023.664-.32.372-.68l-.07-.077-3.297-3.41c-.384-.397-.69-.27-.691.279L5.49 9.724c0 .552.335.697.75.332l.667-.588.82 2.032h-4.23a.997.997 0 0 1-.997-.998V3.498c0-.551.446-.998.998-.998z"
}))));
export default SvgChannelDisplayAd14;